import { render, staticRenderFns } from "./budgetsView.vue?vue&type=template&id=1e3f588d&scoped=true&"
import script from "./budgetsView.vue?vue&type=script&lang=js&"
export * from "./budgetsView.vue?vue&type=script&lang=js&"
import style0 from "./budgetsView.vue?vue&type=style&index=0&id=1e3f588d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3f588d",
  null
  
)

export default component.exports